import { createQueryKeys } from '@lukemorales/query-key-factory';
import { axios } from '@repo/http';
import { useQuery } from '@tanstack/react-query';
import { get_org_people_list_path, GET_ORG_PEOPLE_LIST_PATH } from 'ze-api-contract/organization-v2/get-people-list';
/** @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md */ export const orgPeopleList = createQueryKeys('organization', {
    peopleList: (param)=>{
        let { organization, perPage, page, name } = param;
        return {
            queryKey: [
                GET_ORG_PEOPLE_LIST_PATH,
                organization,
                page,
                perPage,
                name
            ],
            queryFn: async ()=>{
                if (!organization) {
                    return;
                }
                return axios.get(get_org_people_list_path({
                    organization
                }), {
                    params: {
                        page,
                        perPage: Number.isInteger(page) ? perPage : undefined,
                        name
                    }
                }).then((res)=>res.data);
            }
        };
    }
});
/**
 * Get specific organization people list with pagination.
 *
 * @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md
 */ export function useOrganizationPeopleList(params) {
    var _ref, _ref1, _ref2;
    var _data_pageMetadata;
    const { data, isLoading, error } = useQuery(orgPeopleList.peopleList(params));
    const peopleList = (_ref = data === null || data === void 0 ? void 0 : data.entities) !== null && _ref !== void 0 ? _ref : [];
    const peopleListCount = (_ref1 = data === null || data === void 0 ? void 0 : (_data_pageMetadata = data.pageMetadata) === null || _data_pageMetadata === void 0 ? void 0 : _data_pageMetadata.lastPage) !== null && _ref1 !== void 0 ? _ref1 : 0;
    const peopleLimitExceeded = (_ref2 = data === null || data === void 0 ? void 0 : data.peopleLimitExceeded) !== null && _ref2 !== void 0 ? _ref2 : false;
    return {
        peopleList,
        peopleListCount,
        isLoading,
        error,
        peopleLimitExceeded
    };
}
